<template id="map-template">
  <div class="homeview-device-data">
    <div class="header">
      <span class="header-title">设备</span>
      <div class="arrow-pic"></div>
      <!-- <div class="icon-spread"></div> -->
    </div>
    <div class="table-chart">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="TotolCount" label="总数"></el-table-column>
        <el-table-column prop="ExceptionCount" label="故障">
           <template slot-scope="scope">
            <span v-if="scope.row.ExceptionCount > 0" style="color:red;">{{scope.row.ExceptionCount}}</span>
            <span v-else>{{scope.row.ExceptionCount}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import ZJApp from '../../../../../app';

export default {
  name: "HomeViewDeviceList",
  componentName: "HomeViewDeviceList",
  components: {},
  props: {},
  data() {
    return {
      tableData: []
    };
  },
  created() {},
  mounted: function () {
    this.search();
  },
  methods: {
    search(){
      ZJApp.ZJUtils.waitAll([
        () => this.searchLed(),
        () => this.searchMonitor(),
        () => this.searchGate()
      ]).then((r) => {
        this.tableData = r;
      },(e) =>{ console.log(e);});
    },
    searchLed() {
      let searchInfo = {
        Ledtype:  -1 ,
        PageSize: 1000,
        PageIndex: 0,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.LedApi().GetItemPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            //let list  = r.PageContents;
            let exceptionCount = 0;
            let data = {
              Name:"LED",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    searchMonitor() {
      let searchInfo = {
        "EquipmentType": "Monitor",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"摄像头",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    searchGate() {
      let searchInfo = {
        "DeviceType": "Gate",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
    
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return item.IsOnline;}).length;
            let data = {
              Name:"闸机",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    }
  },
  beforeDestroy() {},
  destroyed() {}
};
</script>